// extracted by mini-css-extract-plugin
var _1 = "toast--Na9WINY";
export { _1 as "toast" }
